<template>
  <div class="financial-institution-list-item">
    <div class="meta">
      <router-link class="name" :to="route">{{ name }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "code",
    "route"
  ]
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.financial-institution-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: flex-start;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.meta > .name {
  display: inline-block;
  font-size: 20px;

  &:hover {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/financial-institutions/components/FinancialInstitutionListItem.vue